import React from "react";

function Card(props) {
  const { certificate } = props;
  const { owner, issuer, rank, soulId, description } = certificate;
  const tokenUri = "https://picsum.photos/1000/300";
  return (
    <div className="bg-blue-900 text-white rounded-md shadow-xl hover:shadow transition overflow-hidden">
      <a href={tokenUri} target="_blank" rel="noreferrer">
        <img src={tokenUri} alt={owner} />
      </a>
      <div className="w-full py-10 px-5">
        <h1 className="block text-gray-300 text-xl font-medium mb-1">Owner</h1>
        <h1 className="block font-medium mb-5">{owner}</h1>
        <h1 className="block text-gray-300 text-xl font-medium mb-1">Issuer</h1>
        <h1 className="block font-medium mb-5">{issuer}</h1>
        <h1 className="block text-gray-300 text-xl font-medium mb-1">Soul Id</h1>
        <h1 className="block font-medium mb-5">{soulId}</h1>
        <h1 className="block text-gray-300 text-xl font-medium mb-1">Rank</h1>
        <h1 className="block font-medium mb-5">{rank}</h1>
        <h1 className="block text-gray-300 text-xl font-medium mb-1">Description</h1>
        <h1 className="block font-medium mb-5">{description}</h1>
      </div>
    </div>
  );
}

export default Card;
